import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import DropdownBox from '../../../ui/DropdownBox/DropdownBox'
import Icon from '../../../ui/Icon/Icon'
import { usePopUp } from '../../../hooks/usePopUp'

function LinksRowActions({ onEdit, onDelete }) {
  const buttonRef = useRef(null)
  const menuRef = useRef(null)
  const [isOpen, setIsOpen] = usePopUp(buttonRef, menuRef, true, false)
  const [menuStyle, setMenuStyle] = useState(null)

  const closeMenu = () => setIsOpen(false)

  const updateMenuPosition = () => {
    if (!buttonRef.current) {
      return
    }

    const rect = buttonRef.current.getBoundingClientRect()

    setMenuStyle({
      position: 'fixed',
      top: `${rect.bottom + 4}px`,
      left: `${rect.right}px`,
      transform: 'translateX(-100%)',
      width: 'max-content',
      minWidth: 'unset',
      zIndex: 9999,
      paddingTop: 0,
      right: 'auto',
    })
  }

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    updateMenuPosition()

    const handleReposition = () => updateMenuPosition()

    window.addEventListener('resize', handleReposition)
    window.addEventListener('scroll', handleReposition, true)

    return () => {
      window.removeEventListener('resize', handleReposition)
      window.removeEventListener('scroll', handleReposition, true)
    }
  }, [isOpen])

  const handleEdit = (event) => {
    event.stopPropagation()
    closeMenu()
    onEdit()
  }

  const handleDelete = (event) => {
    event.stopPropagation()
    closeMenu()
    onDelete?.()
  }

  const menu = isOpen ? (
    <DropdownBox
      ref={menuRef}
      className="MarketingLinks-RowActionsMenu registry-actions-menu"
      styles={menuStyle}
    >
      <button type="button" className="DropdownBox-Element MarketingLinks-RowActionsItem" onClick={handleEdit}>
        <Icon name="pencil-alt" size={14} className="MarketingLinks-RowActionsItemIcon" />
        <span className="MarketingLinks-RowActionsItemLabel">Редагувати</span>
      </button>
      {onDelete ? (
        <button type="button" className="DropdownBox-Element MarketingLinks-RowActionsItem" onClick={handleDelete}>
          <Icon name="trash-alt" size={14} className="MarketingLinks-RowActionsItemIcon" />
          <span className="MarketingLinks-RowActionsItemLabel">Видалити</span>
        </button>
      ) : null}
    </DropdownBox>
  ) : null

  return (
    <div className="MarketingLinks-RowActions" onClick={(event) => event.stopPropagation()}>
      <button
        ref={buttonRef}
        type="button"
        className="MarketingLinks-RowActionsTrigger"
        aria-label="Дії"
        onClick={(event) => event.stopPropagation()}
      >
        <Icon name="ellipsis-v" size={14} />
      </button>
      {menu && createPortal(menu, document.body)}
    </div>
  )
}

export default LinksRowActions
